import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '💬',
    title: 'pages.onboarding.goalsQuestion.answer1',
  },
  {
    emoji: '🗣️',
    title: 'pages.onboarding.goalsQuestion.answer2',
  },
  {
    emoji: '📚',
    title: 'pages.onboarding.goalsQuestion.answer3',
  },
  {
    emoji: '🎬',
    title: 'pages.onboarding.goalsQuestion.answer4',
  },
  {
    emoji: '💼',
    title: 'pages.onboarding.goalsQuestion.answer5',
  },
  {
    emoji: '📝',
    title: 'pages.onboarding.goalsQuestion.answer6',
  },
]

export default function GoalsQuestionPage() {
  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.goalsQuestion.title"
    />
  )
}
